import tr from './tr.json';
import en from './en.json';
import fr from './fr.json';
import de from './de.json';
import { LANGUAGE_FALLBACKS, type Language } from '../types';

export type { Language };

export const translations: Record<Language, unknown> = { tr, en, fr, de };

function lookup(key: string, lang: Language): string | undefined {
  let value: unknown = translations[lang];
  for (const k of key.split('.')) {
    if (value && typeof value === 'object') {
      value = (value as Record<string, unknown>)[k];
    } else {
      return undefined;
    }
  }
  return typeof value === 'string' ? value : undefined;
}

/**
 * Get translation by key with variable substitution
 */
export function t(key: string, lang: Language, vars?: Record<string, string>): string {
  // Fallback: FR/DE -> EN -> TR
  let result = key;
  for (const fallback of LANGUAGE_FALLBACKS[lang]) {
    const value = lookup(key, fallback);
    if (value !== undefined) {
      result = value;
      break;
    }
  }

  // Variable substitution
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      result = result.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
    });
  }

  return result;
}
